export enum LastModificationType {
  LastModified = 0,
  LastCreated = 1,
  LastCreatedByMe = 2,
  LastModifiedByMe = 3
}

